export default "__VITE_ASSET__d7d3a757__"